module.exports = kolibriCoreAppGlobal.utils.loginComponents;